import { Controller } from "@hotwired/stimulus"
import { formValidation, plugins } from "formvalidation"
import Bootstrap3 from "formvalidation/plugins/Bootstrap3"

export default class extends Controller {
  static targets = [
    "form",
    "apiKeyField",
    "apiKeyLabel",
    "subdomainField",
    "subdomainLabel",
    "submitButton"
  ]

  connect() {
    this.setupFormValidation()

    this.subdomainFieldTarget.addEventListener("input", this.validateField.bind(this, "subdomainField"))
    this.apiKeyFieldTarget.addEventListener("input", this.validateField.bind(this, "apiKeyField"))
  }

  setupFormValidation() {
    this.fv = formValidation(
      this.formTarget,
      {
        plugins: {
          bootstrap3: new Bootstrap3(),
          trigger: new plugins.Trigger({
            event: "blur"
          })
        },
        fields: {
          apiKeyField: {
            selector: '[name="integrations_syncro[api_key]"]',
            validators: {
              notEmpty: { message: "API Key is required." },
            }
          },
          subdomainField: {
            selector: '[name="integrations_syncro[subdomain]"]',
            validators: {
              notEmpty: { message: "Subdomain is required." },
            }
          }
        }
      }
    )

    this.fv.on("core.field.invalid", (field) => this.toggleLabel(field, true))
    this.fv.on("core.field.valid", (field) => this.toggleLabel(field, false))
  }

  validateField(field) {
    // Trigger the validate so the `core.field.valid/invalid`
    // callback can run and update the label color
    this.fv.validateField(field)
    this.toggleButtonDisable()
  }

  toggleLabel(field, invalid) {
    // Same red used by `formValidation`
    this.labelTargetForInputField(field).style.color = invalid ? "#E74C3C" : null
  }

  labelTargetForInputField(field) {
    const base = field.replace("Field", "")
    return this[`${base}LabelTarget`]
  }

  toggleButtonDisable() {
    // Not running this.fv.validate here to prevent the
    // form fields from all being validated and turning red
    const allFilledOut = (
      this.subdomainFieldTarget.value.length > 0 &&
      this.apiKeyFieldTarget.value.length > 0
    )

    this.submitButtonTarget.disabled = !allFilledOut
  }
}
